
import React from 'react';
import LogoPng from './logo.png';

const Logo = () => {
    return (
        <>
            <div style={{"padding": "25px"}}>
                <img alt="Avi Medical Logo" src={LogoPng} width="200" />
            </div>
        </>
    );
};

export default Logo;
